<template>
    <div>
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>
        <!-- Termina Space -->

        <!-- Buscador Movil -->
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
            <div class="busqueda-contenido3 visible-sm visible-xs">
              <form role="form" @submit.prevent="simpleSearch" method="get" >
                <ul class="list-inline">

                  <li style="width: 77%;"><input v-model="simpleSearchInput" @keyup="getList" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                  <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                  <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li>
                </ul>
                 <div class="autocomplete" v-show="isOpen" >
                          <ul class="autocomplete-results">
                              <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                {{ result.nameRecord }}
                              </li>
                          </ul>
                </div>
                <div class="radio-ww animated slideInRight visible-sm visible-xs">
                  <label class="radio-inline">
                      <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="ww">Who's Who
                      </label>
                    <!-- <label class="radio-inline">
                      <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="guia">OTT
                  </label> -->
              </div>
              </form>
            </div>
            <div class="busq-avanzada">
              <div id="busqavanzada2" class="collapse">
                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="country" v-model="countryIn"  >
                        <option :value="0" selected >-- País --</option>
                        <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                        <option  :value="0"  selected >-- Categoría --</option>
                        <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="activity" v-model="activityIn" >
                        <option  :value="0"  selected >-- Actividad --</option>
                        <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                      </select>
                    </div>
                  </div>
                  </form>
              </div>
            </div>
          </div>
            </div>
        </div>

          <!-- Banner Horizontal -->
    <div class="banner visible-lg visible-md animated slideInDown">
      <div class="container" v-for="(tmpCont,key,index) in resultSearch" v-show=" resultSearchCounter > 0 ">
            <div id="sas_31458" v-if ="resultSearch[key]['company']['WWonlineBannerTopFM'] != ''">
             <script2>{{resultSearch[key]['company']['WWonlineBannerTopFM']}}</script2>
            </div>
      </div>
    </div>

        <!-- Contenido -->
        <div class="contenido-resultados" >
            <div class="container">
                <div class="row">
                   <div class="col-md-8 animated slideInLeft">
                        <div class="tabla-resultado">
                            <div class="titulo-resultado">
                              <h4>RESULTADOS</h4>
                            </div>

                            <div class="resultado-busqueda" v-if="(typeof resultSearch !== 'undefined' )  && resultSearchCounter == 0 "  >
                                <div class="row">
                                    <div class="col-sm-12" align="center">
                                        <h2>No hay resultados de busqueda</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="resultado-busqueda" v-for="(tmpCont,key,index) in resultSearch" v-if="resultSearchCounter>0 && resultSearch" >
                                <div class="row">
                                    <div class="col-md-3" align="center" >
                                        <div class="imagen-persona-res" v-if="resultSearch[key]['company'].Module =='contacto'">

                                           <router-link :to="'/'+resultSearch[key]['company'].Module+'/'+resultSearch[key]['company'].permalink_contacto" class="color">

                                              <!--<img class="feat-image" src="../assets/images/avatar2.png"  v-if="resultSearch[key]['company'].Images==null">-->

                                                <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/'+resultSearch[key]['company'].type+'/'  +( (resultSearch[key]['company'].Images) ? JSON.parse(resultSearch[key]['company'].Images)[0].Subfolder : '' )+'/'+( (resultSearch[key]['company'].Images) ? JSON.parse(resultSearch[key]['company'].Images)[0].path : '' )+')' }" v-if="resultSearch[key]['company'].Images && resultSearch[key]['company'].Module !=='empresa'"  ></div>

                                            </router-link>
                                        </div>

                                       <div class="imagen-persona-empresa" v-if="resultSearch[key]['company'].Module =='empresa'" >

                                               <router-link :to="'/'+resultSearch[key]['company'].Module+((selectedSearchIn=='guia' && resultSearch[key]['company'].Module=='empresa') ? 'OTT' : '')+'/'+resultSearch[key]['company'].permalink_contacto" class="color">

                                                    <img :src="'https://images.produ.com/logos/'+getVerticalContact(resultSearch[key]['company'].Images)" width="100%" ></img>

                                               </router-link>
                                           </div>

                                    </div>
                                    <div class="col-md-9 info-resultado">
                                         <router-link :to="'/'+resultSearch[key]['company'].Module+((selectedSearchIn=='guia' && resultSearch[key]['company'].Module=='empresa') ? 'OTT' : '')+'/'+resultSearch[key]['company'].permalink_contacto" >
                                            <h1 v-html="resultSearch[key]['company'].nameRecord"></h1>
                                        </router-link>
                                        <h2 v-html="resultSearch[key]['company'].Title"  v-if="resultSearch[key]['company'].Module=='contacto'" ></h2>

                                        <router-link v-if="resultSearch[key]['company'].Module=='contacto'" :to="'/empresa'+ ((selectedSearchIn=='guia' )? 'OTT' : '')+'/'+resultSearch[key]['company'].permalink_company" >
                                          <h3  v-html="resultSearch[key]['company'].CompanyName" ></h3>
                                        </router-link>

                                        <p v-html="resultSearch[key]['company'].NombreCategory+' '+resultSearch[key]['company'].NombreActivity" v-if="resultSearch[key]['company'].NombreCategory || resultSearch[key]['company'].NombreActivity" ></p>
                                        <p v-html="resultSearch[key]['company'].citiName"  ></p>
                                        <p class="visible-lg visible-md">{{ resultSearch[key]['company'].Telefono1 | addPlusSign }}</p>
                                        <a :href="'tel:'+resultSearch[key]['company'].Telefono1" class="visible-sm visible-xs" >{{resultSearch[key]['company'].Telefono1 | addPlusSign }}</a>
                                        <a :href="'http://'+resultSearch[key]['company'].URL" target="_blank"><h4 v-html="resultSearch[key]['company'].URL" ></h4></a>
                                    </div>
                                </div>
                            </div>

                            <div class="num-resultados">
                                <h5>{{ resultSearchCounter }} resultados</h5>
                            </div>
                        </div>

                        <div style="margin-top: 10px; margin-left: 50px; text-align: center;">
                          <ul class="pagination list-inline" style=" margin-top: 0px; padding-top: 0px; margin-bottom: 10px;">
                            <li :class="(currentPage-1 == 0 ) ? 'disabled' : '' " >
                            <a @click.prevent="pagination('prev',total_pages,currentPage)" >&laquo;</a></li>

                            <li v-for="value in (total_pages)" :class="(currentPage == value ) ? 'active' : '' "  v-if="total_pages && (typeof total_pages !== 'undefined' ) && (typeof resultSearchCounter !== 'undefined' ) && resultSearchCounter>0 && resultSearch && ( (value <= 10 && currentPage <= 10) || (currentPage > 10 &&  value > aux+1 && value <= currentPage))"   ><a    @click.prevent="currentPage=value;pageNum(currentPage,1)" v-html="value"  ></a></li>
                            <li :class="(total_pages == currentPage ) ? 'disabled' : '' "><a @click.prevent="pagination('next',total_pages,currentPage)"   v-if="resultSearchCounter>0 && resultSearch"   >&raquo;</a></li>
                          </ul>
                        </div>
                   </div>
                   <div class="col-md-4 animated slideInRight">
                        <div class="busqueda-contenido visible-lg visible-md">
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput" @keyup="getList" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada"><i class="fa fa-plus"></i></button></li>
                            </ul>
                             <div class="autocomplete" v-show="isOpen" >
                                <ul class="autocomplete-results">
                                    <li  v-for="(result, i) in contactos" :key="i" @click="setResult(result)" class="autocomplete-opciones">
                                      {{ result.nameRecord }}
                                    </li>
                                </ul>
                           </div>
                           <div class="radio-ww animated slideInRight">
                              <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"   value="ww">Who's Who
                                </label>
                                <!-- <label class="radio-inline">
                                  <input type="radio" v-model="selectedSearchIn" v-on:change="getList"  value="guia">OTT
                              </label> -->
                         </div>
                        </div>
                        <div class="busq-avanzada">
                            <div id="busqavanzada" class="collapse">
                                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="country" v-model="countryIn"  >
                                                <option :value="0" selected >-- País --</option>
                                                <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                                <option  :value="0"  selected >-- Categoría --</option>
                                                <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="activity" v-model="activityIn" >
                                                <option  :value="0"  selected >-- Actividad --</option>
                                                <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                            </select>
                                        </div>
                                    </div>
                                  </form>
                            </div>
                        </div>
                        <div class="banner" v-for="(tmpCont,key,index) in resultSearch" v-show="resultSearchCounter > 0" >
                            <div id="sas_31459" v-if="resultSearch[key]['company']['WWonlineBannerLat1FM'] != ''">
                              <script2>{{resultSearch[key]['company']['WWonlineBannerLat1FM']}}</script2>
                            </div>
                        </div>
                   </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';
//var resfulApi="http://produbackend/admin/index.php/welcome/"
import axios from 'axios';
import '../assets/css/resultado-busqueda.css';

export default {
    name: 'Simplesearch',
    components: {},
    data() {
        return {
            resultSearch: [],
            AdvanceSearchInput: '',
            simpleSearchInput: '',
            resultSearchCounter: 0,

            currentPage: 1,
            query_rows: 10,
            total_pages: 0,
            pageSize: 10,
            page: 1,

            countries: [],
            categories: [],
            activities: [],
            categoryIn: 0,
            contactoIn: '',
            empresaIn: '',
            countryIn: 0,
            activityIn: 0,
            isMobile: false,
            selectedSearchIn: 'ww',
            valuePath: '',
            aux: 1,
            isOpen: false,
            contactos: [],
            permalink: 0,
            auxSearch: {},
            nombres: '',
        };
    },
    created() {},
    methods: {
        moment: function() {
            return moment();
        },
        isActiveSearch() {
            return !this.selectedSearchIn || this.simpleSearchInput.length <= 0
                ? false
                : true;
        },
        simpleSearch: function(e) {
            this.isOpen = false;
            if (this.simpleSearchInput && this.isActiveSearch()) {
                this.buildArreglo();
                this.getContactsBySearchWWFWS(this.auxSearch, 1);
            }
        },
        buildArreglo: function() {
            this.auxSearch.tipo = this.selectedSearchIn;
            this.auxSearch.permalink = this.permalink;
            this.auxSearch.search = this.simpleSearchInput;
            this.auxSearch.nombres =
                this.nombres == '' ? this.simpleSearchInput : this.nombres;
        },
        getActivity: async function() {
            this.activityIn = 0;
            if (this.categoryIn) {
                await axios
                    .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        category: this.categoryIn,
                    })
                    .then(response => {
                        this.activities = response.data;
                        this.$nextTick(function() {});
                    });
            }
        },
        getDataForm: async function() {
            await axios
                .post(resfulApi + 'getCountriesWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(response => {
                    this.countries = response.data.countries;
                    this.categories = response.data.categories;

                    this.$nextTick(function() {});
                });

            this.getActivity();
        },
        advanceSearch: async function() {
            this.$router.push(
                '/advancesearch/' +
                    this.contactoIn +
                    '_' +
                    this.empresaIn +
                    '_' +
                    this.countryIn +
                    '_' +
                    this.categoryIn +
                    '_' +
                    this.activityIn
            );
        },
        getContactsBySearchWWFWS: async function(searchIN, pageIN) {
            this.currentPage = pageIN;
            this.getBanner(this.resultSearch, 1);
            await axios
                .post(resfulApi + 'getContactsBySearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: searchIN,
                    page: pageIN,
                })
                .then(response => {
                    this.resultSearch = [];
                    this.resultSearchCounter = 0;
                    this.total_pages = 0;
                    this.permalink = 0;
                    if (
                        response.data.totalRecordsCont > 0 &&
                        response.data.result
                    ) {
                        this.resultSearch = response.data.result;
                        this.getBanner(response.data.result);
                        this.resultSearchCounter =
                            response.data.totalRecordsCont;

                        this.total_pages =
                            Math.ceil(
                                this.resultSearchCounter / this.query_rows
                            ) - 1;
                        if (
                            (this.resultSearchCounter % this.query_rows) %
                            this.query_rows >
                            0
                        ) {
                            this.total_pages = this.total_pages + 1;
                        }
                    }

                    this.$nextTick(function() {});
                });
        },

        getBanner: async function(data, bandera = null) {
            var aux = '';
            var aux2 = '';
            if (bandera == null) {
                data.forEach(element => {
                    element.company.WWonlineBannerTopFM != '' &&
                    aux == 0 &&
                    element.company.WWonlineBannerTopFM.includes('removed') ==
                        false
                        ? (aux = 1)
                        : (element.company.WWonlineBannerTopFM = null);

                    element.company.WWonlineBannerLat1FM != '' &&
                    aux2 == 0 &&
                    element.company.WWonlineBannerLat1FM.includes('removed') ==
                        false
                        ? (aux2 = 1)
                        : (element.company.WWonlineBannerLat1FM = null);
                });
            } else {
                data.forEach(element => {
                    element.company.WWonlineBannerTopFM = '';
                    element.company.WWonlineBannerLat1FM = '';
                });
            }
        },
        pageNum: async function(currPageIn, pressButtom = null) {
            this.getBanner(this.resultSearch, 1);
            pressButtom ? --this.aux : '';
            this.buildArreglo();
            await axios
                .post(resfulApi + 'getContactsBySearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: this.auxSearch,
                    page: currPageIn,
                })
                .then(response => {
                    if (response.data.totalRecordsCont > 0) {
                        window.scrollTo(0, 0);
                        this.resultSearch = response.data.result;
                        this.getBanner(response.data.result);
                        this.resultSearchCounter =
                            response.data.totalRecordsCont;
                        this.total_pages = 0;

                        this.total_pages =
                            Math.ceil(
                                this.resultSearchCounter / this.query_rows
                            ) - 1;

                        if (this.resultSearchCounter % this.query_rows > 0) {
                            this.total_pages = this.total_pages + 1;
                        }
                    }
                });
        },
        pagination: async function(direction, total_pages, currentPage) {
            if (direction == 'prev') {
                currentPage > 10 ? --this.aux : (this.aux = 0);
                currentPage - 1 == 0 ? '' : this.pageNum(--this.currentPage);
            } else {
                currentPage > 10 ? ++this.aux : (this.aux = 0);
                currentPage == total_pages
                    ? ''
                    : this.pageNum(++this.currentPage);
            }
        },
        getSearchText: async function(arreglo) {
            this.permalink = arreglo.search;
            this.simpleSearchInput = arreglo.nombres;
            this.selectedSearchIn = arreglo.tipo;
        },
        getList: function() {
            this.simpleSearchInput.length > 3
                ? this.getSearchWWFWS()
                : (this.isOpen = false);
        },
        getSearchWWFWS: async function() {
            await axios
                .post(resfulApi + 'getSearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: this.simpleSearchInput,
                    tipo: this.selectedSearchIn,
                })
                .then(response => {
                    this.contactos = response.data;
                    this.contactos.length > 0
                        ? (this.isOpen = true)
                        : (this.isOpen = false);
                });
        },
        setResult: async function(result) {
            this.simpleSearchInput = result.nombres;
            this.permalink = result.permalink;
            this.nombres = result.nombres;
            this.isOpen = false;
            var typeSearch = this.redirectConsulta(
                result.nameRecord,
                result.GuiaOTT
            );
            this.$router.push('/' + typeSearch + '/' + result.permalink);
        },
    },
    beforeMount() {},
    mounted: function() {
        $('body').removeClass('modal-open');
        this.isMobile = this.checkMobile();
        this.getContactsBySearchWWFWS(this.$route.params, 1);
        this.getSearchText(this.$route.params);
        // this.getDataForm();
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filtro-negro a:hover {
    cursor: pointer;
}

a:hover {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Simplesearch.vue